window._ = require('lodash');
window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
require('bootstrap');

//let Promise = require('es6-promise').Promise;
//require('es6-promise/auto');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.baseURL = window.location.protocol+'//'+window.location.host;

window.moment = require('moment');
window.moment.locale('fr');

//import fontawesome from '@fortawesome/fontawesome-pro/js/all.js'


